import { createElementBlock as a, openBlock as o, createElementVNode as l } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function n(t, e) {
  return o(), a("svg", r, [...e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.52 2.82a2.801 2.801 0 1 1 3.156 4.523 4.356 4.356 0 0 1 3.18 4.193v1.555a.73.73 0 0 1-.73.728h-.894l-.453 4.525a.73.73 0 0 1-.725.656H8.946a.73.73 0 0 1-.725-.656l-.453-4.525h-.895a.73.73 0 0 1-.728-.729v-1.554a4.355 4.355 0 0 1 3.179-4.193 2.8 2.8 0 0 1-.805-4.523Zm1.98.637a1.344 1.344 0 1 0 0 2.688 1.344 1.344 0 0 0 0-2.688m-2.05 6.03a2.898 2.898 0 0 1 4.948 2.05v.825h-.826a.73.73 0 0 0-.725.656l-.452 4.525h-1.79l-.452-4.525a.73.73 0 0 0-.725-.656h-.826v-.826a2.9 2.9 0 0 1 .849-2.05Z",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M5.319 4.072a2.283 2.283 0 0 0-1.044 4.314A3.32 3.32 0 0 0 2 11.536v1.555c0 .402.326.728.729.728h.393l.438 3.507a.73.73 0 0 0 .723.638h2.072a.729.729 0 0 0 0-1.457H4.926L4.488 13a.73.73 0 0 0-.723-.638h-.308v-.826A1.86 1.86 0 0 1 5.32 9.674a.729.729 0 0 0 .614-1.12 2.283 2.283 0 0 0-.614-4.482Zm-.584 1.7a.826.826 0 1 1 1.168 1.167.826.826 0 0 1-1.168-1.168Zm9.332-1.031a2.283 2.283 0 1 1 2.658 3.645A3.32 3.32 0 0 1 19 11.536v1.555a.73.73 0 0 1-.729.728h-.393l-.438 3.507a.73.73 0 0 1-.723.638h-2.072a.729.729 0 0 1 0-1.457h1.429L16.512 13a.73.73 0 0 1 .723-.638h.308v-.826a1.86 1.86 0 0 0-1.862-1.862.729.729 0 0 1-.614-1.12 2.283 2.283 0 0 1-1-3.813m1.614.788a.826.826 0 1 0 0 1.652.826.826 0 0 0 0-1.652",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const h = { render: n };
export {
  h as default,
  n as render
};
